export default [
    {
        path: '/payables/overview',

        name: 'Company Payables / Overview',

        component: () => import('@/views/pages/payables/overview'),
    },
    {
        path: '/payables/accounts',

        name: 'Company Payables / Accounts',

        component: () => import('@/views/pages/payables/accounts'),
    },
];